import { KatapultElement, html } from '../../mixins/katapult-element.js';
import '../style-modules/paper-dialog-style.js';
import '@polymer/paper-toast/paper-toast.js';
import '@polymer/paper-dialog/paper-dialog.js';
import { FormatDate } from '../../modules/Date.js';
import { OverwriteAction } from '../../modules/ActionTracking.js';
import SlDrawer from '@shoelace-style/shoelace/dist/components/drawer/drawer.js';
import '@shoelace-style/shoelace/dist/components/divider/divider.js';
/** @import { PaperDialogElement } from '@polymer/paper-dialog/paper-dialog.js' */
/** @import { PaperToastElement } from '@polymer/paper-toast/paper-toast.js' */

class ReplaceActionDialog extends KatapultElement {
  static get template() {
    return html`
      <style include="paper-dialog-style">
        #replaceActionDialog {
          max-width: 500px;
          min-width: 500px;
        }
      </style>
      <paper-toast id="toast"></paper-toast>

      <!-- Dialog for desktop -->
      <paper-dialog
        id="replaceActionDialog"
        entry-animation="scale-up-animation"
        exit-animation="fade-out-animation"
        on-opened-changed="dialogOrDrawerOpenedChanged"
        no-cancel-on-esc-key
        no-cancel-on-outside-click
      >
        <div title secondary-color>Duplicate Action</div>
        <div body style="margin-bottom: 20px;">
          <p>An action already exists on this [[actionCollisionData.itemType]]:</p>
          <paper-table style="margin: 16px; width: 400px;" outline white rounded dividers>
            <paper-row style="height: unset;">
              <paper-cell style="flex: 0 0 auto;">
                <user-chip uid="[[actionCollisionData.oldAction.uid]]"></user-chip>
              </paper-cell>
              <paper-cell style="flex: 2 1 auto; flex-direction: column; align-items: flex-start;">
                <span>[[actionCollisionData.oldAction.action_name]]</span>
                <span style="font-style: italic;" hidden="[[isUndefined(actionCollisionData.oldAction.value)]]"
                  >([[actionCollisionData.oldAction.value]])</span
                >
              </paper-cell>
              <paper-cell style="flex: 0 0 105px;">[[formatDateSeconds(actionCollisionData.oldAction.timestamp.seconds)]]</paper-cell>
            </paper-row>
          </paper-table>
          <p>Do you want to replace this action with:</p>
          <paper-table style="margin: 16px; width: 400px;" outline white rounded dividers>
            <paper-row style="height: unset;">
              <paper-cell style="flex: 0 0 auto;">
                <user-chip uid="[[actionCollisionData.newAction.uid]]"></user-chip>
              </paper-cell>
              <paper-cell style="flex: 2 1 auto; flex-direction: column; align-items: flex-start;">
                <span>[[actionCollisionData.newAction.action_name]]</span>
                <span style="font-style: italic;" hidden="[[isUndefined(actionCollisionData.newAction.value)]]"
                  >([[actionCollisionData.newAction.value]])</span
                >
              </paper-cell>
              <paper-cell style="flex: 0 0 105px;">NOW</paper-cell>
            </paper-row>
          </paper-table>
          <p>This will delete the old action and any feedback associated with it.</p>
        </div>
        <div buttons style="justify-content: space-between;">
          <katapult-button dialog-dismiss>Cancel</katapult-button>
          <div style="display: flex; align-items: center; gap:10px;">
            <div style="font-style: italic; color: var(--secondary-color); margin-right: 10px;">[[replacingActionRes]]</div>
            <katapult-button color="var(--paper-red-500)" on-click="replaceAction">Replace</katapult-button>
            <template is="dom-if" if="[[actionCollisionData.behaviors.duplicate_overwrite_prompt]]">
              <katapult-button color="var(--secondary-color)" data-action="addDuplicate" on-click="replaceAction"
                >Add Duplicate</katapult-button
              >
            </template>
          </div>
        </div>
      </paper-dialog>

      <!-- Bottom sheet (drawer) for mobile -->
      <sl-drawer
        id="replaceActionDrawer"
        label="Duplicate Action"
        placement="bottom"
        style="--size: 70vh;"
        on-sl-after-hide="dialogOrDrawerOpenedChanged"
      >
        <div style="display: flex; flex-direction: column; align-items: flex-start; gap: var(--sl-spacing-small);">
          <div>An action already exists on this node:</div>
          <div>
            <user-chip style="justify-content: flex-start;" uid="[[actionCollisionData.oldAction.uid]]"></user-chip>
            <div>
              <span>[[actionCollisionData.oldAction.action_name]]</span>
              <span style="font-style: italic;" hidden="[[isUndefined(actionCollisionData.oldAction.value)]]"
                >([[actionCollisionData.oldAction.value]])</span
              >
            </div>
            <div>[[formatDateSeconds(actionCollisionData.oldAction.timestamp.seconds)]]</div>
          </div>
          <sl-divider style="align-self: stretch;"></sl-divider>
          <div>Do you want to replace this action with:</div>
          <div>
            <user-chip style="justify-content: flex-start;" uid="[[actionCollisionData.newAction.uid]]"></user-chip>
            <div>
              <span>[[actionCollisionData.newAction.action_name]]</span>
              <span style="font-style: italic;" hidden="[[isUndefined(actionCollisionData.newAction.value)]]"
                >([[actionCollisionData.newAction.value]])</span
              >
            </div>
            <div>NOW</div>
          </div>
          <sl-divider style="align-self: stretch;"></sl-divider>
          <div>This will delete the old action and any feedback associated with it.</div>
          <div
            style="display: flex; flex-direction: column; align-self: center; gap: var(--sl-spacing-medium); width: 100%; margin-top: var(--sl-spacing-medium);"
          >
            <katapult-button color="var(--paper-red-500)" on-click="replaceAction">Replace</katapult-button>
            <template is="dom-if" if="[[actionCollisionData.behaviors.duplicate_overwrite_prompt]]">
              <katapult-button color="var(--secondary-color)" data-action="addDuplicate" on-click="replaceAction"
                >Add Duplicate</katapult-button
              >
            </template>
            <katapult-button on-click="closeDrawer">Cancel</katapult-button>
          </div>
        </div>
      </sl-drawer>
    `;
  }

  static get is() {
    return 'replace-action-dialog';
  }

  static get properties() {
    return {
      userGroup: {
        type: String
      },
      actionCollisions: {
        type: Array,
        value: () => []
      }
    };
  }

  static get observers() {
    return [];
  }

  constructor() {
    super();
    this.isUndefined = (a) => a === undefined;
    this.userGroup = '';
    this.actionCollisions = [];
  }

  connectedCallback() {
    super.connectedCallback();

    this.actionTrackingSuccessHandler = (e) => {
      /** @type { PaperToastElement } */ (this.$.toast).show(`Action recorded: ${e.detail.action.action_name}`);
    };

    this.actionTrackingCollisionHandler = (e) => {
      const replaceActionDialog = /** @type { PaperDialogElement } */ (this.$.replaceActionDialog);
      const replaceActionDrawer = /** @type { SlDrawer } */ (this.$.replaceActionDrawer);
      if (replaceActionDialog.opened || replaceActionDrawer.open) {
        this.actionCollisions.push(e.detail);
        return;
      }

      this.replacingActionRes = '';
      this.actionCollisionData = e.detail;

      if (globalThis.isMobile) {
        replaceActionDrawer.show();
      } else {
        replaceActionDialog.open();
      }
    };

    if (!globalThis.isMobile) window.addEventListener('action-tracking-success', this.actionTrackingSuccessHandler);
    window.addEventListener('action-tracking-collision', this.actionTrackingCollisionHandler);
  }

  disconnectedCallback() {
    super.disconnectedCallback();

    window.removeEventListener('action-tracking-success', this.actionTrackingSuccessHandler);
    window.removeEventListener('action-tracking-collision', this.actionTrackingCollisionHandler);
  }

  ready() {
    super.ready();
  }

  dialogOrDrawerOpenedChanged(e) {
    const replaceActionDialog = /** @type { PaperDialogElement } */ (this.$.replaceActionDialog);
    const replaceActionDrawer = /** @type { SlDrawer } */ (this.$.replaceActionDrawer);

    if ((!replaceActionDialog.opened || !replaceActionDrawer.open) && this.actionCollisions.length) {
      this.actionTrackingCollisionHandler({ detail: this.actionCollisions.shift() });
    }
  }

  closeDrawer() {
    /** @type { SlDrawer } */ (this.$.replaceActionDrawer).hide();
  }

  formatDateSeconds(s) {
    return s ? `${new Date(s * 1000).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })} ${FormatDate(s * 1000)}` : '';
  }

  async replaceAction(e) {
    const target = e.currentTarget;
    target.loading = true;
    const addDuplicate = target.dataset.action == 'addDuplicate';

    try {
      // Ensure the new action has a timestamp
      const newAction = this.actionCollisionData.newAction;
      newAction.timestamp ??= globalThis.firebase.firestore.FieldValue.serverTimestamp();

      if (addDuplicate) {
        const actionTrackingRef = globalThis.firebase.firestore().collection(`companies/${this.userGroup}/action_tracking`);
        await actionTrackingRef.add(newAction);
      } else {
        await OverwriteAction(this.actionCollisionData.oldAction, newAction, this.userGroup, globalThis.firebase.firestore());
      }

      // Notify the user
      target.loading = false;
      target.showSuccess({ duration: 1100 });
      this.replacingActionRes = 'Success!';
      setTimeout(() => {
        if (globalThis.isMobile) {
          /** @type { SlDrawer } */ (this.$.replaceActionDrawer).hide();
        } else {
          /** @type { PaperDialogElement } */ (this.$.replaceActionDialog).close();
        }
      }, 1000);
    } catch (e) {
      target.loading = false;
      target.showError();
      this.replacingActionRes = 'Something went wrong...';
      console.error(e);
    }
  }
}
window.customElements.define(ReplaceActionDialog.is, ReplaceActionDialog);
